module.exports = __webpack_public_path__ + "images/1a1a6ac06ea76c31dc78a6d9bc68e4e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/delivering-happiness.png
// module id = 125
// module chunks = 0